import { render, staticRenderFns } from "./TopBarDropdownItem.vue?vue&type=template&id=604126b5&scoped=true"
import script from "./TopBarDropdownItem.vue?vue&type=script&lang=js"
export * from "./TopBarDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./TopBarDropdownItem.vue?vue&type=style&index=0&id=604126b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604126b5",
  null
  
)

export default component.exports